import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/landing/Navbar';
import HeroSection from '@/components/landing/HeroSection';
import ClientsSection from '@/components/landing/ClientsSection';
import StatsSection from '@/components/landing/StatsSection';
import ServicesSection from '@/components/landing/ServicesSection';
import CasesSection from '@/components/landing/CasesSection';
import TestimonialsSection from '@/components/landing/TestimonialsSection';
import TeamSection from '@/components/landing/TeamSection';
import ContactSection from '@/components/landing/ContactSection';
import PartnersSection from '@/components/landing/PartnersSection';
import PricingSection from '@/components/landing/PricingSection';
import PainSection from '@/components/landing/PainSection';
import Footer from '@/components/landing/Footer';
import { formatMarketingFigures } from '@/config/marketing';

/**
 * The public site (B3-home). Its figures come from config/marketing, like
 * the stats band and the social kit, so the meta description cannot quote
 * other numbers than the page.
 */
export default function Home() {
    const { t, i18n } = useTranslation(['admin']);

    useEffect(() => {
        const figures = formatMarketingFigures(i18n.language);
        document.title = t('admin:landing.meta.title');
        const description = t('admin:landing.meta.description', { calls: figures.calls, satisfaction: figures.satisfaction });
        let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
        if (!meta) {
            meta = document.createElement('meta');
            meta.name = 'description';
            document.head.appendChild(meta);
        }
        meta.setAttribute('content', description);
    }, [t, i18n.language]);

    return (
        <div className="min-h-screen bg-[#0a0a0a] overflow-x-hidden">
            <Navbar />
            <HeroSection />
            <ClientsSection />
            <StatsSection />
            <PainSection />
            <ServicesSection />
            <CasesSection />
            <TestimonialsSection />
            <PricingSection />
            <TeamSection />
            <ContactSection />
            <PartnersSection />
            <Footer />
        </div>
    );
}
